import { ref } from "vue";
import type { UsageDto } from "@chuy/types";
import { api } from "@/api/client";

const usage = ref<UsageDto | null>(null);
const loading = ref(false);
let started = false;

/**
 * Cuánto se ha gastado y, si el servicio de IA lo reporta, cuánto le queda al plan.
 *
 * El servidor cachea la respuesta (preguntarle al plan cuesta abrir una sesión),
 * así que aquí se puede sondear tranquilo cada par de minutos.
 */
export function useUsage() {
  async function refresh(force = false): Promise<void> {
    loading.value = true;
    try {
      usage.value = await api.usage(force);
    } catch {
      // Si no se puede consultar, la barra de arriba simplemente no enseña nada.
    } finally {
      loading.value = false;
    }
  }

  if (!started) {
    started = true;
    void refresh();
    setInterval(() => {
      if (document.visibilityState === "visible") void refresh();
    }, 120_000);
  }

  return { usage, loading, refresh };
}
